import React from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'sonner';
import { App } from './App';
import { ThemeProvider } from './components/ThemeProvider';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
      <Toaster
        richColors
        closeButton
        position="bottom-right"
        toastOptions={{ classNames: { toast: 'font-sans' } }}
      />
    </ThemeProvider>
  </React.StrictMode>,
);

// Custom element type for <model-viewer> so JSX/TS accept it
declare global {
  namespace JSX {
    interface IntrinsicElements {
      'model-viewer': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> & {
        src?: string;
        alt?: string;
        'camera-controls'?: boolean;
        'auto-rotate'?: boolean;
        'shadow-intensity'?: string | number;
        exposure?: string | number;
        'environment-image'?: string;
        loading?: 'auto' | 'lazy' | 'eager';
        reveal?: 'auto' | 'manual';
        poster?: string;
        'disable-zoom'?: boolean;
        'interaction-prompt'?: 'auto' | 'none' | 'when-focused';
        autoplay?: boolean;
        'animation-name'?: string;
        ref?: React.Ref<HTMLElement>;
      };
    }
  }
}
